import React, { useRef } from 'react'
import { useProviderContext } from '../../context/MapProviderContext'

export const generateGeoData = async (state) => {
    const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${state}&key=AIzaSyAnTPIxJIgdXe-0Ibr79aM19Hdmh1qxavw`);
    return response.json();
}

const LocationInput = () => {
    const postcodeRef = useRef()
    const {
        options,
        setOptions,
        config
    } = useProviderContext()

    const handleSubmit = (Event) => {
        Event.preventDefault()
        handlePostcodeUpdate(Event)
    }

    const handlePostcodeUpdate = async (Event) => {
        const data = await generateGeoData(postcodeRef.current.value)

        const update = await data?.results.map(location => {
            const res = location.address_components.find(({ long_name }) => long_name === "Nordrhein-Westfalen");
            if (!res) {
                return {
                    status: 'BAD',
                    lat: options.center.lat,
                    lng: options.center.lng,
                }
            }

            return {
                status: 'OK',
                lat: location?.geometry?.location?.lat,
                lng: location?.geometry?.location?.lng,
            }
        })

        if (update[0]?.status !== 'OK') {
            setOptions({
                ...options,
                zoom: config.map.zoom_level.on_location_failed,
                location_status: update[0]?.status
            })

            return
        }

        setOptions({
            ...options,
            center: {
                lat: update[0]?.lat,
                lng: update[0]?.lng
            },
            zoom: config.map.zoom_level.on_location_success,
            postcode: postcodeRef.current.value,
            location_status: update[0]?.status
        })
    }

    return (
        <div className="flex flex-wrap">
            <form onSubmit={(Event) => handleSubmit(Event)} className="flex-1 flex flex-col">
                <h3>{config.content.location_input_label.heading}</h3>
                <input
                    type="text"
                    name="postcode"
                    id='postcode'
                    ref={postcodeRef}
                    placeholder={config.content.location_input_label.placeholder}
                    aria-label={config.content.location_input_label.aria_label}
                    onChange={(Event) => handlePostcodeUpdate(Event)}
                    className='flex-1 rounded-full px-4 py-3 shadow-[5px_10px_10px_-10px_rgba(0,0,0,0.2)_inset] border border-brand-dark-500/10 text-[1rem]'
                />
            </form>
        </div>
    )
}

export default LocationInput
